export type AvatarDetail = {
  avatars: AvatarConfig[]
  gridBackgroundColor: string
  gridBackgroundImage: string
  gridTitleColor: string
  rooms: any
}

export enum AvatarVideoSize {
  sixteenByNine = 1,
  square = 2,
  fullscreen = 3
}

export enum AvatarGesture {
  drag = 1,
  move = 2
}

export type AvatarConfig = {
  id?: number
  avatarName: string
  avatarPhoto?: string
  avatarId: string
  avatarDescription: string
  videoSize: AvatarVideoSize
  gesture: AvatarGesture
  avatarDescription3d?: string
  avatarId3d?: string
  avatarImage3d?: string
  bubbleImage?: string
  gesture3d?: AvatarGesture
  videoSize3d?: AvatarVideoSize
  position?: number
  useDH?: boolean
  additionalArgs?: string[]
  avatarId2d?: string // this field is not really returned in the backend. it's just that avatarId is non specific and may get overwritten with either the 2d or 3d id, so we back up the 2d value into a dedicated field. TODO: come up with a solution to remove this
  debugUrl?: string
  useDebugUrl: boolean
  languages: Language[]
}

type Language = {
  language: string
  languageCode: string
  languagePosition: number
}

export type AvatarsErrorMessageType = {
  title: string
  message: string
}
